export default __webpack_public_path__ + "static/media/2.81a5c20a.jpg";